import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { NavigationBar } from '../Components/navigationbar/NavigationBar';
import { Footer } from '../Components/Layout/footer/Footer';
// import classes from './landingPage.module.scss'

export function LandingPage() {
  return (
    <div className="container-fluid">
      <div className="row min-vh-100">
        <div className="col p-0">
          <div className="sticky-top p-0 mb-0 ">
            <NavigationBar />
          </div>
          <Outlet />
        </div>
        <div className="mt-auto p-0">
          <Footer />
        </div>
      </div>
    </div>
  );
}
